import { NotificationDTO, useNotificationStore } from '@/store/notification'

export const DEBUG_ENABLED = process.env.VUE_APP_DEBUG_ENABLED === 'true'

export function DEBUG(...data: any[]) {
    if (DEBUG_ENABLED) {
        console.log(data)
    }
}

export function DEBUGC(text: string, color: string) {
    if (DEBUG_ENABLED) {
        console.log(`%c ${text}`, `background-color: ${color}`)
    }
}

type stringObject = {
    [key: string]: any
}

export function DEBUG_VAR(dataWrapper: stringObject) {
    if (DEBUG_ENABLED) {
        for (const prop in dataWrapper) {
            console.log(`${prop}:`, dataWrapper[prop])
        }
    }
}

export function DEBUG_WARN(...data: any[]) {
    if (DEBUG_ENABLED) {
        console.warn(data)
        const notificationStore = useNotificationStore()
        notificationStore.addNotification(NotificationDTO.createForDebug(data.toString(), 'warning', 60000))
    }
}

export function DEBUG_ERR(...data: any[]) {
    console.error(data)
    const notificationStore = useNotificationStore()

    if (DEBUG_ENABLED) {
        notificationStore.addNotification(NotificationDTO.createForDebug(data.toString(), 'error', 86400000))
    }
    else {
        notificationStore.addNotification(new NotificationDTO(data.toString(), 'error'))
    }
}

export function DEBUG_ERR_WITHOUT_PROD_NOTIFICATION(...data: any[]) {
    console.error(data)

    if (DEBUG_ENABLED) {
        const notificationStore = useNotificationStore()
        notificationStore.addNotification(NotificationDTO.createForDebug(data.toString(), 'error', 86400000))
    }
}